import { useCookieDeclaration } from '$/hooks/useCookieDeclaration';

export const CookieDeclarationPage = () => {
  useCookieDeclaration();

  return null;
};
